import {
	SUB_PROFILE_RULES_FETCH,
	SUB_PROFILE_RULES_IS_FETCING,
	SUB_PROFILE_RULES_EDIT
} from 'constants/subProfileRules'

export default function subProfileRulesReducer(state = {
    list: []
}, action) {
    switch (action.type) {
        case SUB_PROFILE_RULES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case SUB_PROFILE_RULES_EDIT:
            return {
                ...state,
            }
        case SUB_PROFILE_RULES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/subProfileRules.js